import { render, staticRenderFns } from "./WhatsNewBarHorizontal.vue?vue&type=template&id=47b2433a&scoped=true&"
import script from "./WhatsNewBarHorizontal.vue?vue&type=script&lang=js&"
export * from "./WhatsNewBarHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./WhatsNewBarHorizontal.vue?vue&type=style&index=0&id=47b2433a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2433a",
  null
  
)

export default component.exports